module.exports = __webpack_public_path__ + "img/applyResult_tip.b8c6b706.png";